module.exports = "//static.hsappstatic.net/ecosystem-marketplace-apps-ui/static-1.2723/img/callout-blobs.svg"


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/ecosystem-marketplace-apps/node_modules/bender-webpack/lib/bender-url-loader.js!./img/callout-blobs.svg
// module id = 895
// module chunks = 209 210 211 212